import ChecksList from './ChecksList/index';
import CheckDetails from './CheckDetails/index';
import styles from "./checksBody.module.scss"
import cn from "classnames";
// return body component accourding to view CheckTilesView or table list 
const Body = (props) => {
    return (
        <div className='row mx-0 fs-12 h-100'>
            <div className='col-8 px-0 h-100'><ChecksList {...props} /></div>
            <div className={cn('col-4  pr-0 text-white fw-400', styles.checkdetails)}><CheckDetails {...props} /></div>
        </div>
    )
}
export default Body;